import BonusText from 'components/Offers/fragments/BonusText/BonusText';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { InfoCircleOutlined } from '@ant-design/icons';
import classnames from 'classnames';

export const CreditCardAdditionalText = props => {
  const {
    offerMetadata,
    containerType,
    bodyContentType,
    isPlus,
    hideNAFields,
  } = props;

  const {
    introBtOverrideText,
    introPurchaseOverrideText,
    rewardsBonusTextShort,
    rewardsBonusTextLong,
    signupBonusTextShort,
    signupBonusTextLong,
    btText,
  } = offerMetadata;

  const fontClass = classnames('Subtitle-3 pointer', {
    fontWhite: isPlus,
    fontGray400: !isPlus,
  });

  const getIntroBalance = () => {
    return introBtOverrideText ?? 'N/A';
  };

  const getIntroPurchase = () => {
    return introPurchaseOverrideText ?? 'N/A';
  };

  const getBalanceTransferFee = () => {
    return btText ?? 'N/A';
  };

  const hideIntroBalanceAprNA = hideNAFields && getIntroBalance() === 'N/A';
  const hideIntroPurchaseAprNA = hideNAFields && getIntroPurchase() === 'N/A';
  const hideBalanceTransferFee =
    hideNAFields && getBalanceTransferFee() === 'N/A';

  if (bodyContentType === 'BALANCE_TRANSFER') {
    return (
      <FlexContainer
        className={'flex-column gap-6'}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {!hideIntroBalanceAprNA && (
          <Label className={fontClass}>
            <span>
              <BonusText
                type={'Intro Balance Transfer APR:'}
                bonusTextShort={getIntroBalance()}
                titleClass={'bold'}
                tooltipIcon={InfoCircleOutlined}
              />
            </span>
          </Label>
        )}
        {!hideIntroPurchaseAprNA && (
          <Label className={fontClass}>
            <BonusText
              type={'Intro Purchase APR:'}
              bonusTextShort={getIntroPurchase()}
              titleClass={'bold'}
              tooltipIcon={InfoCircleOutlined}
            />
          </Label>
        )}
        {!hideBalanceTransferFee && (
          <Label className={fontClass}>
            <BonusText
              type={'Balance Transfer Fee:'}
              bonusTextShort={getBalanceTransferFee()}
              titleClass={'bold'}
              tooltipIcon={InfoCircleOutlined}
            />
          </Label>
        )}
      </FlexContainer>
    );
  } else if (
    containerType === 'SUGGESTED_REWARDS_CARDS' ||
    containerType === 'CASH_BACK_CARDS' ||
    bodyContentType === 'REWARDS' ||
    bodyContentType === 'CASH_BACK'
  ) {
    return (
      <FlexContainer
        className={'flex-column gap-6'}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <Label className={fontClass}>
          <span>
            <BonusText
              type={'Rewards:'}
              bonusTextShort={rewardsBonusTextShort}
              bonusTextLong={rewardsBonusTextLong}
              titleClass={'bold'}
              tooltipIcon={InfoCircleOutlined}
            />
          </span>
        </Label>
        <Label className={fontClass}>
          <BonusText
            type={'Bonus Offer:'}
            bonusTextShort={signupBonusTextShort}
            bonusTextLong={signupBonusTextLong}
            titleClass={'bold'}
            tooltipIcon={InfoCircleOutlined}
          />
        </Label>
      </FlexContainer>
    );
  } else if (
    containerType === 'SUGGESTED_BALANCE_TRANSFER_CARDS' ||
    bodyContentType === 'BALANCE_TRANSFER'
  ) {
    return (
      <FlexContainer
        className={'flex-column gap-6'}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {!hideIntroBalanceAprNA && (
          <Label className={fontClass}>
            <span>
              <BonusText
                type={'Intro Balance Transfer APR:'}
                bonusTextShort={getIntroBalance()}
                titleClass={'bold'}
                tooltipIcon={InfoCircleOutlined}
              />
            </span>
          </Label>
        )}
        {!hideIntroBalanceAprNA && (
          <Label className={fontClass}>
            <BonusText
              type={'Intro Purchase APR:'}
              bonusTextShort={getIntroPurchase()}
              titleClass={'bold'}
              tooltipIcon={InfoCircleOutlined}
            />
          </Label>
        )}
        {!hideBalanceTransferFee && (
          <Label className={fontClass}>
            <BonusText
              type={'Balance Transfer Fee:'}
              bonusTextShort={getBalanceTransferFee()}
              titleClass={'bold'}
              tooltipIcon={InfoCircleOutlined}
            />
          </Label>
        )}
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};
